import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmptyCustomSectionColumn = ({
  message,
  title = 'addSectionPanel.customSections.noCustomSectionsTitle',
  searchQuery
}) => {
  const formattedTitle = /*#__PURE__*/_jsx(FormattedMessage, {
    message: title,
    options: {
      searchTerm: searchQuery
    }
  });
  const shouldDisplayTitleAsHeader = Boolean(message);
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    marginBlockStart: "1100",
    children: /*#__PURE__*/_jsxs(View, {
      inlineSize: "350px",
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: "empty-state-charts",
        width: "60%"
      }), /*#__PURE__*/_jsx(FoundationsView, {
        marginBlockStart: "400",
        as: "div",
        children: shouldDisplayTitleAsHeader ? /*#__PURE__*/_jsx(H2, {
          marginBlockStart: "400",
          children: formattedTitle
        }) : formattedTitle
      }), message]
    })
  });
};
export default EmptyCustomSectionColumn;